import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLastDefined } from '../../hooks/useLastDefined';
import { Collapsible } from '../Collapsible/Collapsible';
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
import { Box } from '../layout/Box';
import { FlexContainer } from '../layout/FlexContainer';
import { ExpansionTableRow } from './ExpansionTableRow';
import { ExpansionTableRowCardWrapper } from './ExpansionTableRowCardWrapper';
const CARD_CONTENT_SPACING = { spacing: '0' };
const rowMinHeight = '48px';
const wrapWithCard = (children) => (_jsx(ExpansionTableRowCardWrapper, { contentSpacing: CARD_CONTENT_SPACING, children: children }));
export const ExpansionTableExpansionRow = ({ id, row, columns, detail, leftRowElement, headerTestId, hasAllRowsExpanded, showIconPlaceholder: showIconPlaceholder, tableHasDetail, onHeaderClick, }) => {
    // To prevent jumping when closing
    const definedDetail = useLastDefined(detail);
    const open = !!detail;
    const shouldWrapWithButton = tableHasDetail && !showIconPlaceholder && !hasAllRowsExpanded;
    const mappedColumns = columns.map((column) => {
        const content = column.render(row) ?? '-';
        const wrappedContentVariant = column.boldText ? 'h6' : 'b2';
        const maybeWrappedContent = typeof content === 'string' ? (_jsx(FlexContainer, { horizontalAlign: column.horizontalAlign, children: _jsx(Text, { variant: wrappedContentVariant, children: content }) })) : (content);
        return {
            key: column.key,
            grow: column.grow,
            testId: column.testId,
            content: maybeWrappedContent,
        };
    });
    const expansionRow = (_jsx(Box, { spacing: true, children: _jsx(ExpansionTableRow, { columns: mappedColumns, open: open, showIconPlaceholder: showIconPlaceholder, tableHasDetail: tableHasDetail, hasAllRowsExpanded: hasAllRowsExpanded }) }));
    const clickableExpansionRow = shouldWrapWithButton ? (_jsx(PlainButton, { testId: headerTestId, onClick: onHeaderClick, children: expansionRow })) : (expansionRow);
    const maybeWrappedWithCardClickableExpansionRow = hasAllRowsExpanded
        ? wrapWithCard(clickableExpansionRow)
        : clickableExpansionRow;
    const expansionTableExpansionRow = (_jsxs(_Fragment, { children: [_jsxs(FlexContainer, { id: id, verticalAlign: 'center', minHeight: rowMinHeight, children: [leftRowElement, _jsx(FlexContainer, { grow: 1, direction: 'column', children: maybeWrappedWithCardClickableExpansionRow })] }), _jsx(Collapsible, { open: open, children: _jsx(Box, { spacing: true, children: definedDetail }) })] }));
    const maybeWrappedWithCardExpansionTableExpansionRow = hasAllRowsExpanded
        ? expansionTableExpansionRow
        : wrapWithCard(expansionTableExpansionRow);
    return maybeWrappedWithCardExpansionTableExpansionRow;
};
